<script setup lang="ts">
import SearchSelect from "../../ui/form/SearchSelect.vue";
import TextInput from "../../ui/form/TextInput.vue";
import CheckInput from "../../ui/form/CheckInput.vue";
import TextAreaInput from "../../ui/form/TextAreaInput.vue";
import { ref, onMounted } from "vue";
import ModalFormTemplate from "../../../components/ui/Templates/ModalFormTemplate.vue";
import { useFormValidation } from "../../../composables/useFormValidation";
import { required } from "../../../utils/validation";
import {
  Field,
  ReportDesign,
  Table,
  OperationOptions,
  MatchTypeOptions,
  fieldTypeOptions,
} from "../../../types/report";
import { api } from "../../../api/Api";
import { mapSqlTypeToVueType } from "../../../types/mapSqlTypeToVueType";
import Toast from "../../../services/Toast";
import RadioInput from "../../ui/form/RadioInput.vue";
import GridInput from "../../ui/form/GridInput.vue";
import Buttons from "../../ui/form/Buttons.vue";
import MessageBox from "../../../services/MessageBox";
import IconComponent from "../../ui/common/IconComponent.vue";

const props = defineProps<{
  report?: ReportDesign;
  title: string;
  data?: any;
  table?: Table;
  field?: Field;
  child?: boolean
  group?: any
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus";
}>();

const emit = defineEmits<{
  (e: "addField", data: any): void;
  (e: "close"): void;
}>();

const {
  fields,
  formData,
  setFieldRules,
  validateForm,
  resetForm,
  setFormData,
} = useFormValidation({
    id: props.data?.id || "field_" + Math.random().toString(36).substring(2, 15),
    table: props.data?.table || "",
    tableAlias: props.data?.tableAlias || "",
    fieldName: props.data?.fieldName || "",
    operator: props.data?.operator || "",
    matchType: props.data?.matchType || "",
    dbTable: props.data?.dbTable || "",
    dbTableAlias: props.data?.dbTableAlias || "",
    dbNameField: props.data?.dbNameField || "",
    dbIdField: props.data?.dbIdField || "",
    required: props.data?.required || false,
    inputType: props.data?.inputType || 'text',
    value: props.data?.value || "",
    group: props.data?.group || false,
    childFilters:  props.data?.childFilters || [],
    sqlQuery: props.data?.sqlQuery || '',
    raw: props.data?.raw || false,
    rawQuery: props.data?.rawQuery || '',
    condition: props.data?.condition || '',
    caption: props.data?.caption || '',
    hidden: props.data?.hidden || false, // Optional: Whether the filter is hidden
});

setFieldRules("id", [required("Table is required")]);
setFieldRules("inputType", [required("Input Type is required")]);
setFieldRules("caption", !fields.value.group.value ? [required("Caption is required")] : []);
setFieldRules("childFilters", fields.value.group.value ? [required("Filter Groups require one or more Filters in the group")] : []);
setFieldRules("condition", (!props.child && props.report?.filters.length || 0 > 0) || (props.child && props.group?.childFilters?.length || 0 > 0) ? [required("Condition is required")] : []);
setFieldRules("tableAlias", !fields.value.group.value ? [required("Table is required")]: []);
setFieldRules("fieldName", !fields.value.group.value ? [required("Field is required")]: []);
setFieldRules("operator", !fields.value.group.value ? [required("Operator is required")]: []);
setFieldRules("matchType", !fields.value.group.value ? [required("Match Type is required")]: []);
setFieldRules("dbTableAlias", !fields.value.group.value  && fields.value.matchType.value != 'Value' ? [required("List Table is required")]: []);
setFieldRules("dbNameField", !fields.value.group.value  && fields.value.matchType.value != 'Value' ? [required("List Name Field is required")]: []);
setFieldRules("dbIdField", !fields.value.group.value  && fields.value.matchType.value != 'Value' ? [required("List ID Field is required")]: []);

const tableFields = ref<any[]>([])
const getFields = async (table: any) => {
  try {
    const response = await api.post("/clients/reports/fields", {
      table: table.id,
    });
    if (response.success == true) {
      let data = response.data;
      data.forEach((field: { field_type: string; }) => {
        field.field_type = mapSqlTypeToVueType(field.field_type);
      });
      tableFields.value = data;
    }
  } catch (error) {
    Toast.show(String(error) || "Failed to fetch Source Fields", "error");
  }
}

const sourceFields = ref<Field[]>([]);
const getSourceFields = async (table: Table) => {
  if (!table) {
    sourceFields.value = []
    return
  }
  try {
    const response = await api.post("/clients/reports/fields", {
      table: table.id,
    });
    if (response.success == true) {
      let data = response.data;
      data.forEach((field: { field_type: string; }) => {
        field.field_type = mapSqlTypeToVueType(field.field_type);
      });
      sourceFields.value = data;
    }
  } catch (error) {
    Toast.show(String(error) || "Failed to fetch Source Fields", "error");
  }
};

const handleSubmit = async () => {
  setFieldRules("caption", !fields.value.group.value ? [required("Caption is required")] : []);
setFieldRules("childFilters", fields.value.group.value ? [required("Filter Groups require one or more Filters in the group")] : []);
setFieldRules("condition", (!props.child && props.report?.filters.length || 0 > 0) || (props.child && props.group?.childFilters?.length || 0 > 0) ? [required("Condition is required")] : []);
setFieldRules("tableAlias", !fields.value.group.value && !fields.value.raw.value ? [required("Table is required")]: []);
setFieldRules("fieldName", !fields.value.group.value && !fields.value.raw.value ? [required("Field is required")]: []);
setFieldRules("operator", !fields.value.group.value ? [required("Operator is required")]: []);
setFieldRules("matchType", !fields.value.group.value ? [required("Match Type is required")]: []);
setFieldRules("dbTableAlias", !fields.value.group.value  && fields.value.matchType.value == 'DB Field' ? [required("List Table is required")] : []);
setFieldRules("dbNameField", !fields.value.group.value  && fields.value.matchType.value == 'DB Field' ? [required("List Name Field is required")] : []);
setFieldRules("dbIdField", !fields.value.group.value  && fields.value.matchType.value == 'DB Field' ? [required("List ID Field is required")] : []);
  console.log(fields.value.matchType.value)
  console.log(formData.value)
  console.log(validateForm())
  console.log(fields.value)
  if (validateForm()) {
    console.log("Form Data:", formData.value);
    emit("addField", formData.value);
  }
};

const isReadOnly = ref(true);
onMounted(() => {
    console.log('field to add', props.field)
  isReadOnly.value = props.mode == "view";
  if (props.mode == "create") {
    resetForm();
    //setField()
  } else if (props.data) {
    setFormData(props.data);
  }

  console.log(props.child)
  console.log(props.group)
  console.log((!props.child && props.report?.filters.length || 0 > 0) || (props.child && props.group?.childFilters?.length || 0 > 0))
});

const showAddChildFilter = ref(false)
const selectedField = ref<Field>()

const addFieldToGroup = (field: any) => {
  fields.value.childFilters.value.push(field)
  showAddChildFilter.value = false
}

const removeFilter = (index: number) => {
  MessageBox.confirm({
        title: 'Confirm Delete',
        message: 'Are you sure you want to delete the table (' + fields.value.childFilters.value[index].displayName + ')?', 
        confirmText: 'Yes, Delete',
        cancelText: "Cancel",
      }).then((confirmed: any) => {
        if (confirmed) {
          fields.value.childFilters.value.splice(index, 1);
        }
      });
}

</script>
<template>
  <ModalFormTemplate
    :data="data"
    :mode="mode"
    :title="title"
    endPoint=""
    :perm="[]"
    :tabList="[]"
    :formData="formData"
    @save="handleSubmit"
    :ignore-permission="true"
    @close="$emit('close')"
  >
    <template #form>
      <div class="grid md:grid-cols-4 gap-6">
        <div class="col-span-4 grid md:grid-cols-4 gap-6">
          <CheckInput
            label="Group"
            v-model="fields.group.value"
            v-if="!props.child"
            class="col-span-1"
            :error="
              fields.group.touched ? fields.group.error : null
            "
            @blur="fields.group.touched = true"
          />
          <RadioInput
          v-model="fields.condition.value"
          name="Condition"
          v-if="(!props.child && props.report?.filters.length || 0 > 0) || (props.child && props.group?.childFilters?.length || 0 > 0)"
          :options="[
            {id: 'AND', name: 'AND'},
            {id: 'OR', name: 'OR'}
          ]"
          :error="
              fields.condition.touched ? fields.condition.error : null
            "
            @blur="fields.condition.touched = true" />

             <CheckInput
            label="Required"
            v-if="!fields.group.value"
            v-model="fields.required.value"
            class="col-span-1"
            :error="
              fields.required.touched ? fields.required.error : null
            "
            @blur="fields.required.touched = true"
          />

            <CheckInput
            label="SQL Function"
            v-if="!fields.group.value"
            v-model="fields.raw.value"
            class="col-span-1"
            :error="
              fields.raw.touched ? fields.raw.error : null
            "
            @blur="fields.raw.touched = true"
          />
          <CheckInput
            label="Hidden"
            v-model="fields.hidden.value"
            class="col-span-1"
            :error="
              fields.hidden.touched ? fields.hidden.error : null
            "
            @blur="fields.hidden.touched = true"
          />
          <SearchSelect
            label="Input Type"
            v-model="fields.inputType.value"
            class="col-span-1"
             v-if="!fields.group.value"
            :error="
              fields.inputType.touched ? fields.inputType.error : null
            "
            @blur="fields.inputType.touched = true"
            :options="fieldTypeOptions"
          />
        </div>
        <div class="col-span-4 grid md:grid-cols-3 gap-6">
        <SearchSelect
            label="Table"
            v-model="fields.tableAlias.value"
            class="col-span-1"
             v-if="!fields.raw.value && !fields.group.value"
             @select="getFields"
            :error="
              fields.tableAlias.touched ? fields.tableAlias.error : null
            "
            @blur="fields.tableAlias.touched = true"
            :options="report?.tables?.map(t => ({ id: t.alias, name: t.displayName }))"
          />
        <SearchSelect
            label="Field Name"
            v-if="!fields.raw.value && !fields.group.value"
            v-model="fields.fieldName.value"
            class="col-span-1"
            :error="
              fields.fieldName.touched ? fields.fieldName.error : null
            "
            @blur="fields.fieldName.touched = true"
            :options="tableFields"
          />
          <TextInput
            v-model="fields.caption.value"
            v-if="!fields.group.value"
            label="Caption"
            class="w-full"
            :readonly="isReadOnly"
            :error="fields.caption.touched ? fields.caption.error : null"
            @blur="fields.caption.touched = true" />
            </div>
            <TextAreaInput
            v-model="fields.sqlQuery.value"
            v-if="!fields.raw.value && !fields.group.value"
            label="SQL Function"
            class="w-full col-span-4"
            :readonly="isReadOnly"
            :error="fields.sqlQuery.touched ? fields.sqlQuery.error : null"
            @blur="fields.sqlQuery.touched = true" />
          <div class="col-span-4">
          <TextAreaInput
            v-model="fields.rawQuery.value"
            label="SQL Query"
            class="w-full"
            v-if="fields.raw.value && !fields.group.value"
            :readonly="isReadOnly"
            :error="fields.rawQuery.touched ? fields.rawQuery.error : null"
            @blur="fields.rawQuery.touched = true" />
        </div>
        <SearchSelect
            label="Operator"
            v-model="fields.operator.value"
            v-if="!fields.group.value"
            :error="
              fields.operator.touched ? fields.operator.error : null
            "
            @blur="fields.operator.touched = true"
            :options="OperationOptions"
          />
        <SearchSelect
            label="Match Type"
            v-model="fields.matchType.value"
            v-if="!fields.group.value"
            :error="
              fields.matchType.touched ? fields.matchType.error : null
            "
            @blur="fields.matchType.touched = true"
            :options="MatchTypeOptions"
          />
          <TextAreaInput
            v-model="fields.value.value"
            v-if="fields.matchType.value != 'DB Field'"
            label="Value"
            class="w-full col-span-2"
            :readonly="isReadOnly"
            :error="fields.value.touched ? fields.value.error : null"
            @blur="fields.value.touched = true" />
          <div class="col-span-4 md:grid md:grid-cols-4 md:gap-2" v-if="fields.matchType.value == 'DB Field'">
        <SearchSelect
          label="Table"
          v-model="fields.dbTableAlias.value"
          class="col-span-2"
          @select="getSourceFields"
          :error="fields.dbTableAlias.touched ? fields.dbTableAlias.error : null"
          @blur="fields.dbTableAlias.touched = true"
          custom-url="reports/tables"
          placeholder="Select Table"
        />

        <SearchSelect
          label="ID Field"
          v-model="fields.dbIdField.value"
          :options="sourceFields"
          class="col-span-1"
          :error="fields.dbIdField.touched ? fields.dbIdField.error : null"
          @blur="fields.dbIdField.touched = true"
        />

        <SearchSelect
          label="Display Field"
          v-model="fields.dbNameField.value"
          :options="sourceFields"
          class="col-span-1"
          :error="fields.dbNameField.touched ? fields.dbNameField.error : null"
          @blur="fields.dbNameField.touched = true"
        />

          </div>
          
      </div>
      <div v-if="fields.group.value">
        <div id="add-raw-field">
      <Buttons
        caption="Add Group Filter"
        icon="Plus" 
        @click="showAddChildFilter = true"
      />
      </div>
        <GridInput label="Group Filters" class="mt-2">
          <div class="relative hidden md:block">
            <div v-if="fields.childFilters.value.length === 0" class="empty-state">
              <p>No Filters added. Click "Add Filter" to add filters to the Group.</p>
            </div>
            <table  class="divide-y divide-gray-200 dark:divide-gray-700 w-full" v-else>
              <thead class="bg-gray-50 dark:bg-gray-800">
              <tr class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                <th class="text-left">Condition</th>
                <th class="text-left">Table Name</th>
                <th class="text-left">Field Name</th>
                <th class="text-left">Operator</th>
                <th class="text-left">Match Type</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider sticky right-0 bg-gray-50 dark:bg-gray-800 shadow-l">...</th>
              </tr>
              </thead>
              <tbody class="bg-white text-sm py-4 dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
              <tr v-for="(filter, index) in fields.childFilters.value" :key="index" class="hover:bg-gray-100 dark:hover:bg-gray-700">                
                <td class="py-4">{{ filter.condition }}</td>
                <td class="py-4">{{ filter.tableAlias }}</td>
                <td class="py-4">{{ filter.fieldName }}</td>
                <td class="py-4">{{ filter.operator }}</td>
                <td class="py-4">{{ filter.matchType }}</td>
                <td class="whitespace-nowrap text-right sticky right-0 shadow-l">
                  <button
                    id="table-action-remove-table"
                   @click="removeFilter(index)"
                    class="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-600"
                    title="Delete Table"
                  >
                    <IconComponent name="Trash2"/>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </GridInput>
      </div>
      <AddFilterField
        v-if="showAddChildFilter"
        :child="true"
        :report="report"
        :mode="selectedField ? 'edit' : 'create'"
        :title="selectedField ? 'Edit' + selectedField.name + '('+ selectedField.alias +')' : 'Add New Field'"
        :data="selectedField"
        :group="formData"
        @close="showAddChildFilter = false"
        @addField="addFieldToGroup" />
    </template>
  </ModalFormTemplate>
</template>
